import React, { useState } from "react";
import styles from "./Footer.module.css";
import { Info24Regular, PersonFeedback24Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const { t } = useTranslation();
    return (
        <footer className={styles.footer}>
            <span className={styles.footerContent}>
                <b>GSK - Clarify with AI</b>
                <span className={styles.separator}>|</span>
                <span
                    className={styles.disclaimer}
                    onMouseEnter={() => setShowDisclaimer(true)}
                    onMouseLeave={() => setShowDisclaimer(false)}
                    tabIndex={0}
                    onFocus={() => setShowDisclaimer(true)}
                    onBlur={() => setShowDisclaimer(false)}
                    aria-label={t("disclaimer") + ": " + t("disclaimerNotice")}
                >
                    <Info24Regular className={styles.infoIcon} /> {t("disclaimer", "Disclaimer")}
                    {showDisclaimer && (
                        <span className={styles.tooltip}>
                            {t(
                                "disclaimerNotice",
                                "As with any Gen AI tool, outputs from Clarify with AI require careful and diligent human review to ensure accuracy and appropriateness of response. The sender of the email is responsible for ensuring compliance with all GSK policies as appropriate, including Acceptable use of Tech Policy and Privacy Policy."
                            )}
                        </span>
                    )}
                </span>
                <span className={styles.separator}>|</span>
                <a
                    className={styles.feedbackLink}
                    href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=_yqYY2z7IkyXO3DkrPtj5kSYMmOBhjhPmikxHmLbhXJURVpTSDVYU1dLTUpWRElMS0NKUk5XUlJRNC4u&route=shorturl"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PersonFeedback24Regular className={styles.infoIcon} /> {t("feedbackText", "Share your feedback or questions")}{" "}
                    <span className={styles.feedbackHere}>{t("feedbackHere", "here.")}</span>
                </a>
            </span>
        </footer>
    );
};

export default Footer;
